import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { FaArrowLeft, FaBookOpen } from "react-icons/fa";
import DocsService from "../services/DocsService";

export default function DocPage() {
    const { slug } = useParams();
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let alive = true;
        setLoading(true);
        setError(null);
        (async () => {
            try {
                const data = await DocsService.getDoc(slug);
                if (alive) setDoc(data);
            } catch (err) {
                if (!alive) return;
                if (err.response?.status === 404) {
                    setError("Documentação não encontrada.");
                } else {
                    setError("Erro ao carregar a documentação.");
                }
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, [slug]);

    return (
        <div className="flex w-full h-full justify-center items-start py-4 px-4 bg-gray-200">
            <div className="flex flex-col w-full h-full rounded-xl py-6 px-6 gap-4 bg-white overflow-y-auto">
                <div className="flex items-center justify-between gap-2 ps-2">
                    <Link
                        to="/app/docs"
                        className="flex items-center gap-2 text-sm text-gray-600 hover:text-blue-600"
                    >
                        <FaArrowLeft />
                        Voltar para a lista
                    </Link>
                    {doc?.updatedAt && (
                        <span className="text-xs text-gray-500">
                            Última atualização: {new Date(doc.updatedAt).toLocaleString()}
                        </span>
                    )}
                </div>

                {loading && <div className="text-sm text-gray-500 ps-2">Carregando...</div>}
                {error && <div className="text-sm text-red-600 ps-2">{error}</div>}

                {!loading && !error && doc && (
                    <article className="prose prose-slate max-w-none px-2 prose-headings:scroll-mt-24 prose-pre:bg-slate-900 prose-pre:text-slate-100 prose-code:before:content-none prose-code:after:content-none">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {doc.markdown}
                        </ReactMarkdown>
                    </article>
                )}

                <div className="flex items-center gap-2 text-xs text-gray-400 ps-2 pt-4 border-t border-gray-200">
                    <FaBookOpen />
                    <span>Vision API Docs</span>
                </div>
            </div>
        </div>
    );
}
